// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__d70bV","messages":"Chat_messages__1ZsOl","dateDivider":"Chat_dateDivider__1itHN"};